export default __webpack_public_path__ + "static/media/login-footer-logo.87de8828.svg";